import INFTCollections from '../../models/INFTCollections'
import AvawareAllenCard from '../../nftFormats/AvawareAllen/Card/AvawareAllenCard'
import AvawareAllenDetail from '../../nftFormats/AvawareAllen/Detail/AvawareAllenDetail'
import AvawareAllenActivtyDetail from '../../nftFormats/AvawareAllen/Activity/AvawareAllenActivtyDetail'

import AvawareAllen1Logo from '../../../../assets/nft-logo/AvawareAllen1.jpg'
import AvawareAllen2Logo from '../../../../assets/nft-logo/AvawareAllen2.jpg'
import AvawareAllen3Logo from '../../../../assets/nft-logo/AvawareAllen3.jpg'
import AvawareAllen4Logo from '../../../../assets/nft-logo/AvawareAllen4.jpg'
import AvawareAllen5Logo from '../../../../assets/nft-logo/AvawareAllen5.jpg'
import AvawareAllen6Logo from '../../../../assets/nft-logo/AvawareAllen6.png'

const social = {
  website: 'https://avaware.network/nft',
  twitter: 'AvawareAVE',
  telegram: 'https://t.me/avavaware',
  discord: 'https://discord.com/invite/B8RTbe4yur'
}

export const AvawareAllenData: INFTCollections[] = [
  {
    id: 'AvawareAllen1',
    tokenAddress: '0x64fec1537ce16488f78b472c47a2c66104133920',
    name: 'Allen Says Hi!',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvawareAllen1Logo,
    ...social
  },
  {
    id: 'AvawareAllen2',
    tokenAddress: '0xf841d808511e5887946c6dc466c9a8a49aafbc72',
    name: 'Allen In Space!',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvawareAllen2Logo,
    ...social
  },
  {
    id: 'AvawareAllen3',
    tokenAddress: '0x4ddf6bdefe3c1ceeb6cccd9edb4b82a65d320e15',
    name: 'Allen Holds $AVE!',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvawareAllen3Logo,
    ...social
  },
  {
    id: 'AvawareAllen4',
    tokenAddress: '0x272161ee1182e5a2568c2ed2b40d36b54107f40d',
    name: 'Allen Enters The Matrix',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvawareAllen4Logo,
    ...social
  },
  {
    id: 'AvawareAllen5',
    tokenAddress: '0x87b98d82982c6a0ec7173a0c8cad8436972ab08d',
    name: 'Allen Mines Crypto',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvawareAllen5Logo,
    ...social
  },
  {
    id: 'AvawareAllen6',
    tokenAddress: '0x38f64e98cd4b7cba50c0bb5d94de974f2918cd10',
    name: 'Allen Goes 3Do',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvawareAllen6Logo,
    ...social
  }
]

export const AvawareAllenCategoryData = {
  [AvawareAllenData[0].tokenAddress.toLowerCase()]: AvawareAllenData[0].category,
  [AvawareAllenData[1].tokenAddress.toLowerCase()]: AvawareAllenData[1].category,
  [AvawareAllenData[2].tokenAddress.toLowerCase()]: AvawareAllenData[2].category,
  [AvawareAllenData[3].tokenAddress.toLowerCase()]: AvawareAllenData[3].category,
  [AvawareAllenData[4].tokenAddress.toLowerCase()]: AvawareAllenData[4].category,
  [AvawareAllenData[5].tokenAddress.toLowerCase()]: AvawareAllenData[5].category,
}
